import {
    COLOR_CATAPULT_BLACK,
    COLOR_CATAPULT_ORANGE,
    COLOR_CATAPULT_WHITE,
    COLOR_DARK_FOCUS_OVERLAY,
    COLOR_DARK_HOVER_OVERLAY,
    COLOR_DARK_SELECTED_OVERLAY,
    COLOR_DKSFC_ALERT_RED,
    COLOR_DKSFC_ALERT_RED_BG,
    COLOR_DKSFC_ALERT_RED_TEXT,
    COLOR_DKSFC_INFORMATION_BLUE,
    COLOR_DKSFC_INFORMATION_BLUE_BG,
    COLOR_DKSFC_INFORMATION_BLUE_TEXT,
    COLOR_DKSFC_SUCCESS_GREEN,
    COLOR_DKSFC_SUCCESS_GREEN_BG,
    COLOR_DKSFC_SUCCESS_GREEN_TEXT,
    COLOR_DKSFC_WARNING_YELLOW,
    COLOR_DKSFC_WARNING_YELLOW_BG,
    COLOR_DKSFC_WARNING_YELLOW_TEXT,
    COLOR_DKSFC_ONBOARDING_INDIGO,
    COLOR_DKSFC_ONBOARDING_INDIGO_BG,
    COLOR_FOCUS_RING,
    COLOR_GREY_1,
    COLOR_GREY_2,
    COLOR_GREY_3,
    COLOR_GREY_4,
    COLOR_GREY_5,
    COLOR_GREY_6,
    COLOR_GREY_7,
    COLOR_LIGHT_FOCUS_OVERLAY,
    COLOR_LIGHT_HOVER_OVERLAY,
    COLOR_LIGHT_SELECTED_OVERLAY,
    COLOR_LTSFC_ALERT_RED,
    COLOR_LTSFC_ALERT_RED_BG,
    COLOR_LTSFC_ALERT_RED_TEXT,
    COLOR_LTSFC_INFORMATION_BLUE,
    COLOR_LTSFC_INFORMATION_BLUE_BG,
    COLOR_LTSFC_INFORMATION_BLUE_TEXT,
    COLOR_LTSFC_SUCCESS_GREEN,
    COLOR_LTSFC_SUCCESS_GREEN_BG,
    COLOR_LTSFC_SUCCESS_GREEN_TEXT,
    COLOR_LTSFC_WARNING_YELLOW,
    COLOR_LTSFC_WARNING_YELLOW_BG,
    COLOR_LTSFC_WARNING_YELLOW_TEXT,
    COLOR_LTSFC_ONBOARDING_INDIGO,
    COLOR_LTSFC_ONBOARDING_INDIGO_BG,
    COLOR_ORANGE_1,
    COLOR_ORANGE_2,
    COLOR_ORANGE_3,
    COLOR_ORANGE_4,
    COLOR_ORANGE_5,
    COLOR_ORANGE_6,
    COLOR_INDIGO_1,
    COLOR_INDIGO_2,
    COLOR_INDIGO_3,
    COLOR_INDIGO_4,
    COLOR_INDIGO_5,
    FONT_BODY,
    SHADOW_1,
    SHADOW_2,
    SHADOW_3,
    SHADOW_4,
    SPACING_12,
    SPACING_16,
    SPACING_24,
    SPACING_32,
    SPACING_4,
    SPACING_40,
    SPACING_48,
    SPACING_8,
    COLOR_LIGHT_TEAL,
    COLOR_LIGHT_TEAL_SHADE,
    COLOR_LIGHT_SLATE,
    COLOR_LIGHT_SLATE_SHADE,
    COLOR_LIGHT_VIOLET,
    COLOR_LIGHT_VIOLET_SHADE,
    COLOR_LIGHT_BLUE,
    COLOR_LIGHT_BLUE_SHADE,
    COLOR_DARK_TEAL,
    COLOR_DARK_TEAL_SHADE,
    COLOR_DARK_SLATE,
    COLOR_DARK_SLATE_SHADE,
    COLOR_DARK_VIOLET,
    COLOR_DARK_VIOLET_SHADE,
    COLOR_DARK_BLUE,
    COLOR_DARK_BLUE_SHADE,
} from '@SBGSports/referee-design-tokens';
import { css } from 'linaria';

/**
 *  Design system tokens as CSS Variables
 *
 *  - We prefix it with `--r` (referee) to differentiate as core variables
 */
const vars = {
    // Common
    fontBody: '--r-font-body',
    focusRing: '--r-focus-ring',

    catapultOrange: '--r-catapult-orange',
    catapultBlack: '--r-catapult-black',
    catapultWhite: '--r-catapult-white',

    spacing4: '--r-spacing-4',
    spacing8: '--r-spacing-8',
    spacing12: '--r-spacing-12',
    spacing16: '--r-spacing-16',
    spacing24: '--r-spacing-24',
    spacing32: '--r-spacing-32',
    spacing40: '--r-spacing-40',
    spacing48: '--r-spacing-48',

    grey1: '--r-grey-1',
    grey2: '--r-grey-2',
    grey3: '--r-grey-3',
    grey4: '--r-grey-4',
    grey5: '--r-grey-5',
    grey6: '--r-grey-6',
    grey7: '--r-grey-7',

    orange1: '--r-orange-1',
    orange2: '--r-orange-2',
    orange3: '--r-orange-3',
    orange4: '--r-orange-4',
    orange5: '--r-orange-5',
    orange6: '--r-orange-6',

    indigo1: '--r-indigo-1',
    indigo2: '--r-indigo-2',
    indigo3: '--r-indigo-3',
    indigo4: '--r-indigo-4',
    indigo5: '--r-indigo-5',

    shadow1: '--r-shadow-1',
    shadow2: '--r-shadow-2',
    shadow3: '--r-shadow-3',
    shadow4: '--r-shadow-4',

    teal: '--r-teal',
    tealShade: '--r-teal-shade',
    slate: '--r-slate',
    slateShade: '--r-slate-shade',
    violet: '--r-violet',
    violetShade: '--r-violet-shade',
    blue: '--r-blue',
    blueShade: '--r-blue-shade',
    hoverOverlay: '--r-hover-overlay',
    focusOverlay: '--r-focus-overlay',
    selectedOverlay: '--r-selected-overlay',

    textBody: '--r-text-body',
    textBackground: '--r-text-background',
    textSecondary: '--r-text-secondary',
    textSecondaryPlus: '--r-text-secondary-plus',
    textTertiary: '--r-text-tertiary',
    textLink: '--r-text-link',

    spinnerPrimary: '--r-spinner-primary',
    spinnerSecondary: '--r-spinner-secondary',
    spinnerMuted: '--r-spinner-muted',

    selectClearable: '--r-select-clearable',

    information: '--r-information',
    informationBg: '--r-information-bg',
    informationText: '--r-information-text',
    success: '--r-success',
    successBg: '--r-success-bg',
    successText: '--r-success-text',
    warning: '--r-warning',
    warningBg: '--r-warning-bg',
    warningText: '--r-warning-text',
    alert: '--r-alert',
    neutral: '--r-neutral',
    alertBg: '--r-alert-bg',
    alertText: '--r-alert-text',
    onboarding: '--r-onboarding',
    onboardingBg: '--r-onboarding-bg',
    clearable: '--r-clearable',

    tableForeground: '--r-table-foreground',
    tableBackground: '--r-table-background',
    tableOddRowColor: '--r-table-odd-row-color',
    tableRowBorderColor: '--r-table-row-border-color',
    tableScrollbarThumbColor: '--r-table-scrollbar-thumb-color',
};

// Make sure both dark and light modes have SAME set of variable names
export const globalVariablesCSS = css`
    :global() {
        :root {
            ${vars.fontBody}: ${FONT_BODY};
            ${vars.focusRing}: ${COLOR_FOCUS_RING};

            ${vars.catapultOrange}: ${COLOR_CATAPULT_ORANGE};
            ${vars.catapultBlack}: ${COLOR_CATAPULT_BLACK};
            ${vars.catapultWhite}: ${COLOR_CATAPULT_WHITE};

            ${vars.spacing4}: ${SPACING_4}px;
            ${vars.spacing8}: ${SPACING_8}px;
            ${vars.spacing12}: ${SPACING_12}px;
            ${vars.spacing16}: ${SPACING_16}px;
            ${vars.spacing24}: ${SPACING_24}px;
            ${vars.spacing32}: ${SPACING_32}px;
            ${vars.spacing40}: ${SPACING_40}px;
            ${vars.spacing48}: ${SPACING_48}px;

            ${vars.grey1}: ${COLOR_GREY_1};
            ${vars.grey2}: ${COLOR_GREY_2};
            ${vars.grey3}: ${COLOR_GREY_3};
            ${vars.grey4}: ${COLOR_GREY_4};
            ${vars.grey5}: ${COLOR_GREY_5};
            ${vars.grey6}: ${COLOR_GREY_6};
            ${vars.grey7}: ${COLOR_GREY_7};

            ${vars.orange1}: ${COLOR_ORANGE_1};
            ${vars.orange2}: ${COLOR_ORANGE_2};
            ${vars.orange3}: ${COLOR_ORANGE_3};
            ${vars.orange4}: ${COLOR_ORANGE_4};
            ${vars.orange5}: ${COLOR_ORANGE_5};
            ${vars.orange6}: ${COLOR_ORANGE_6};

            ${vars.indigo1}: ${COLOR_INDIGO_1};
            ${vars.indigo2}: ${COLOR_INDIGO_2};
            ${vars.indigo3}: ${COLOR_INDIGO_3};
            ${vars.indigo4}: ${COLOR_INDIGO_4};
            ${vars.indigo5}: ${COLOR_INDIGO_5};

            ${vars.shadow1}: ${SHADOW_1};
            ${vars.shadow2}: ${SHADOW_2};
            ${vars.shadow3}: ${SHADOW_3};
            ${vars.shadow4}: ${SHADOW_4};
        }

        // Dark and light modes MUST have same set of variable names
        [data-theme='light'] {
            ${vars.teal}: ${COLOR_LIGHT_TEAL};
            ${vars.tealShade}: ${COLOR_LIGHT_TEAL_SHADE};
            ${vars.slate}: ${COLOR_LIGHT_SLATE};
            ${vars.slateShade}: ${COLOR_LIGHT_SLATE_SHADE};
            ${vars.violet}: ${COLOR_LIGHT_VIOLET};
            ${vars.violetShade}: ${COLOR_LIGHT_VIOLET_SHADE};
            ${vars.blue}: ${COLOR_LIGHT_BLUE};
            ${vars.blueShade}: ${COLOR_LIGHT_BLUE_SHADE};
            ${vars.hoverOverlay}: ${COLOR_LIGHT_HOVER_OVERLAY};
            ${vars.focusOverlay}: ${COLOR_LIGHT_FOCUS_OVERLAY};
            ${vars.selectedOverlay}: ${COLOR_LIGHT_SELECTED_OVERLAY};

            ${vars.textBody}: ${COLOR_CATAPULT_BLACK};
            ${vars.textBackground}: ${COLOR_CATAPULT_WHITE};
            ${vars.textSecondary}: ${COLOR_GREY_2};
            ${vars.textSecondaryPlus}: ${COLOR_GREY_3};
            ${vars.textTertiary}: ${COLOR_GREY_4};
            ${vars.textLink}: ${COLOR_ORANGE_1};

            ${vars.spinnerPrimary}: ${COLOR_CATAPULT_ORANGE};
            ${vars.spinnerSecondary}: ${COLOR_CATAPULT_BLACK};
            ${vars.spinnerMuted}: ${COLOR_GREY_3};

            ${vars.selectClearable}: ${COLOR_GREY_5};

            ${vars.information}: ${COLOR_LTSFC_INFORMATION_BLUE};
            ${vars.informationBg}: ${COLOR_LTSFC_INFORMATION_BLUE_BG};
            ${vars.informationText}: ${COLOR_LTSFC_INFORMATION_BLUE_TEXT};
            ${vars.alert}: ${COLOR_LTSFC_ALERT_RED};
            ${vars.neutral}: ${COLOR_GREY_5};
            ${vars.alertBg}: ${COLOR_LTSFC_ALERT_RED_BG};
            ${vars.alertText}: ${COLOR_LTSFC_ALERT_RED_TEXT};
            ${vars.success}: ${COLOR_LTSFC_SUCCESS_GREEN};
            ${vars.successBg}: ${COLOR_LTSFC_SUCCESS_GREEN_BG};
            ${vars.successText}: ${COLOR_LTSFC_SUCCESS_GREEN_TEXT};
            ${vars.warning}: ${COLOR_LTSFC_WARNING_YELLOW};
            ${vars.warningBg}: ${COLOR_LTSFC_WARNING_YELLOW_BG};
            ${vars.warningText}: ${COLOR_LTSFC_WARNING_YELLOW_TEXT};
            ${vars.onboarding}: ${COLOR_LTSFC_ONBOARDING_INDIGO};
            ${vars.onboardingBg}: ${COLOR_LTSFC_ONBOARDING_INDIGO_BG};
            ${vars.clearable}: ${COLOR_ORANGE_3};

            ${vars.tableForeground}: ${COLOR_CATAPULT_BLACK};
            ${vars.tableBackground}: ${COLOR_CATAPULT_WHITE};
            ${vars.tableOddRowColor} ${COLOR_GREY_6};
            ${vars.tableRowBorderColor}: ${COLOR_GREY_5};
            ${vars.tableScrollbarThumbColor}: ${COLOR_GREY_5};
        }

        // Dark and light modes MUST have same set of variable names
        [data-theme='dark'] {
            ${vars.teal}: ${COLOR_DARK_TEAL};
            ${vars.tealShade}: ${COLOR_DARK_TEAL_SHADE};
            ${vars.slate}: ${COLOR_DARK_SLATE};
            ${vars.slateShade}: ${COLOR_DARK_SLATE_SHADE};
            ${vars.violet}: ${COLOR_DARK_VIOLET};
            ${vars.violetShade}: ${COLOR_DARK_VIOLET_SHADE};
            ${vars.blue}: ${COLOR_DARK_BLUE};
            ${vars.blueShade}: ${COLOR_DARK_BLUE_SHADE};
            ${vars.hoverOverlay}: ${COLOR_DARK_HOVER_OVERLAY};
            ${vars.focusOverlay}: ${COLOR_DARK_FOCUS_OVERLAY};
            ${vars.selectedOverlay}: ${COLOR_DARK_SELECTED_OVERLAY};

            ${vars.textBody}: ${COLOR_CATAPULT_WHITE};
            ${vars.textBackground}: ${COLOR_CATAPULT_BLACK};
            ${vars.textSecondary}: ${COLOR_GREY_5};
            ${vars.textSecondaryPlus}: ${COLOR_GREY_5};
            ${vars.textTertiary}: ${COLOR_GREY_4};
            ${vars.textLink}: ${COLOR_ORANGE_2};

            ${vars.spinnerPrimary}: ${COLOR_ORANGE_2};
            ${vars.spinnerSecondary}: ${COLOR_CATAPULT_WHITE};
            ${vars.spinnerMuted}: ${COLOR_GREY_4};

            ${vars.selectClearable}: ${COLOR_GREY_4};

            ${vars.information}: ${COLOR_DKSFC_INFORMATION_BLUE};
            ${vars.informationBg}: ${COLOR_DKSFC_INFORMATION_BLUE_BG};
            ${vars.informationText}: ${COLOR_DKSFC_INFORMATION_BLUE_TEXT};
            ${vars.alert}: ${COLOR_DKSFC_ALERT_RED};
            ${vars.neutral}: ${COLOR_GREY_5};
            ${vars.alertBg}: ${COLOR_DKSFC_ALERT_RED_BG};
            ${vars.alertText}: ${COLOR_DKSFC_ALERT_RED_TEXT};
            ${vars.success}: ${COLOR_DKSFC_SUCCESS_GREEN};
            ${vars.successBg}: ${COLOR_DKSFC_SUCCESS_GREEN_BG};
            ${vars.successText}: ${COLOR_DKSFC_SUCCESS_GREEN_TEXT};
            ${vars.warning}: ${COLOR_DKSFC_WARNING_YELLOW};
            ${vars.warningBg}: ${COLOR_DKSFC_WARNING_YELLOW_BG};
            ${vars.warningText}: ${COLOR_DKSFC_WARNING_YELLOW_TEXT};
            ${vars.onboarding}: ${COLOR_DKSFC_ONBOARDING_INDIGO};
            ${vars.onboardingBg}: ${COLOR_DKSFC_ONBOARDING_INDIGO_BG};
            ${vars.clearable}: ${COLOR_ORANGE_3};

            ${vars.tableForeground}: ${COLOR_CATAPULT_WHITE};
            ${vars.tableBackground}: ${COLOR_CATAPULT_BLACK};
            ${vars.tableOddRowColor} ${COLOR_GREY_2};
            ${vars.tableRowBorderColor}: ${COLOR_GREY_3};
            ${vars.tableScrollbarThumbColor}: ${COLOR_GREY_3};

            @media print {
                ${vars.textBody}: ${COLOR_CATAPULT_BLACK};
                ${vars.textBackground}: ${COLOR_CATAPULT_WHITE};
                ${vars.textSecondary}: ${COLOR_GREY_3};
                ${vars.textSecondaryPlus}: ${COLOR_GREY_3};
                ${vars.textTertiary}: ${COLOR_GREY_4};
                ${vars.textLink}: ${COLOR_GREY_4};

                ${vars.information}: ${COLOR_LTSFC_INFORMATION_BLUE};
                ${vars.success}: ${COLOR_LTSFC_SUCCESS_GREEN};
                ${vars.warning}: ${COLOR_LTSFC_WARNING_YELLOW};
                ${vars.alert}: ${COLOR_LTSFC_ALERT_RED};
                ${vars.onboarding}: ${COLOR_LTSFC_ONBOARDING_INDIGO};
            }
        }
    }
`;

type T = typeof vars & { css?: T };

export const Variables: T = new Proxy(vars, {
    get: (target, prop, receiver) => {
        if (prop === 'css') {
            return new Proxy(vars, {
                get: (...args) => `var(${Reflect.get(...args)})`,
            });
        }

        return Reflect.get(target, prop, receiver);
    },
});
